import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { DocumentAIService } from '../../services/documentAI.service';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-shared-case-panel',
  templateUrl: './shared-case-panel.component.html',
  styleUrl: './shared-case-panel.component.scss'
})
export class SharedCasePanelComponent implements OnInit {
  @Input() caseId: any;
  getCaseRecordTypeIdFilter: any;
  caseRecordTypeId: any;
  data: any;
  displayList: { label: string; value: string }[] = [];
  headers: CaseField[] = [];
  @ViewChildren('fadeElements') fadeElements!: QueryList<ElementRef>;

  constructor(
    public authService: AuthService, private service: DocumentAIService,
    private route: ActivatedRoute,
    private http: HttpClient // Add HttpClient for direct API calls
  ) {

  }

  ngOnInit(): void {
    this.loadHeadersAndData()
  }

loadHeadersAndData() {
  this.service.getCaseRecordForEdit(this.caseId).subscribe((res: any) => {
    this.data = res.result.caseRecord || {};
    this.getCaseRecordTypeIdFilter = this.data.caseRecordTypeId;
    this.caseRecordTypeId = this.data.caseRecordTypeId;
    this.displayList = []; // Clear previous
    if (this.caseRecordTypeId) {
      this.service.getFormLayout(this.caseRecordTypeId).subscribe((dataheader: any) => {
        this.headers = dataheader.result || [];
        const normalizedData: any = {};
        Object.keys(this.data).forEach(key => {
          normalizedData[key.toLowerCase()] = this.data[key];
        });

        // Parse customFieldsValues JSON if present
        let customFieldsArr: any[] = [];
        if (typeof this.data.customFieldsValues === 'string') {
          try {
            customFieldsArr = JSON.parse(this.data.customFieldsValues);
          } catch {
            customFieldsArr = [];
          }
        } else if (Array.isArray(this.data.customFieldsValues)) {
          customFieldsArr = this.data.customFieldsValues;
        }
        this.headers
          .filter((header: any) => header.isCustom !== true && header.IsCustom !== true) // Hide isCustom: true fields; show all others
          .sort((a: any, b: any) => (a.displayOrder || 0) - (b.displayOrder || 0)) // Sort by displayOrder like case-view
          .forEach(header => {
          const normalizedFieldName = header.fieldName.toLowerCase();
          let value = normalizedData[normalizedFieldName];
          if (!value || value === 'N/A') {
            const customField = customFieldsArr.find(
              (f: any) => f.fieldName?.toLowerCase() === normalizedFieldName
            );
            value = customField?.Data ?? 'N/A';
          }

          this.displayList.push({ label: header.fieldName, value });
        });
      });
    }

  });
}
isDate(value: any): boolean {
  return !isNaN(Date.parse(value));
}

openCaseView(): void {
  if (this.caseId) {
    const url = `/case/view/${this.caseId}`;
    window.open(url, '_blank');
  }
}

  // fadeInElements() {
  //   this.fadeElements.forEach((el, index) => {
  //       // setTimeout(() => {
  //         el.nativeElement.classList.add('show');
  //       // }, index * 100); // Delay each item by 500ms
  //     });
  // }
}


interface CaseField {
  fieldName: string;
  caseRecordName: string;
  Id: number;
}
